import { defaultTheme } from '@withjoy/joykit/theme';

// `@media ` stripped: these feed <source media> and <link media>, which take the bare query.
const asMediaAttribute = (query: string): string => query.replace(/^@media\s+/, '');

/**
 * The viewport ranges Brannan's theme-art canvases are on screen for (bundled path, PRNT-4898):
 * the stacked frames from sm4 (960px) up, the title banner below it — `isSmallScreen` in CSS
 * terms. Passed to ThemeSprites as `media` so a canvas the server rendered from a wrong
 * User-Agent guess resolves to a blank image instead of downloading art hydration then discards.
 * The server's preload links (themeArtPreload.tsx) hardcode the same two strings because they
 * cannot import joykit; LayoutBrannan.theme.spec pins these to those literals. The frames range is
 * also where LayoutBrannanSinglePage renders StickyNavBar, which the cinematic header controller reads.
 */
export const BRANNAN_FRAMES_MEDIA = asMediaAttribute(defaultTheme.mediaQueries.up({ breakpointAlias: 'sm4' }));
export const BRANNAN_TITLE_BANNER_MEDIA = asMediaAttribute(defaultTheme.mediaQueries.between(0, { breakpointAlias: 'sm4' }));
